import { render, staticRenderFns } from "./PropertyOptionCreate.vue?vue&type=template&id=e287de68&"
import script from "./PropertyOptionCreate.vue?vue&type=script&lang=js&"
export * from "./PropertyOptionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports